import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Radio.module.scss';
import RadioGroupContext from '../RadioGroup/RadioGroupContext';

function Radio(props) {
  const { id, value, disabled, label } = props;
  const { name, selectedValue, onChange } = useContext(RadioGroupContext);

  const checked = useMemo(() => selectedValue === value, [selectedValue, value]);
  const handleOnChange = useCallback(() => onChange(value), [onChange, value]);

  return (
    <label className={cn(styles.container, disabled ? styles.disabled : '')} htmlFor={id}>
      <input
        type="radio"
        disabled={disabled}
        id={id}
        name={name}
        value={value}
        aria-checked={checked}
        checked={checked}
        onChange={handleOnChange}
      />
      <div className={cn(styles.icon, checked ? 'ic-radiobutton' : 'ic-radiobutton-outline')} />
      {label ? (
        <span className={styles.label}>{label}</span>
      ) : (
        <div className={styles.radioContent}>{props.children}</div>
      )}
    </label>
  );
}

export default Radio;

Radio.defaultProps = {
  label: undefined,
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};
